module.exports = __webpack_public_path__ + "f8888e2bb518252f1dadd428ca37295b.svg";